module.exports = __webpack_public_path__ + "static/media/GD.c15511a1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/GD.svg
// module id = 2156
// module chunks = 7